import { IndexComponentConfigInterface, Vault } from '@/types';
import { PageList } from '@prometheus/features';
import { setBreadcrumbs } from '@prometheus/redux';
import React, { FC, useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { vaultListConfig } from './VaultList.config';
import { getUUID } from '@prometheus/utils';
import { ModalContext, UseModalContext } from '@prometheus/hooks';
import { CreateVault } from '../CreateVault/CreateVault';

export const VaultList: FC<{
  root: any;
}> = ({ root }) => {
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const { openModal, closeModal } = useContext<UseModalContext>(ModalContext);
  const [idReload, setIdReload] = useState(getUUID());
  const onCreateVault = (e?: any, vault?: Vault) => {
    openModal(
      () => (
        <CreateVault
          defaultValue={vault}
          isEdit={Boolean(vault)}
          onClose={() => {
            closeModal();
            setIdReload(getUUID());
          }}
        />
      ),
      vault ? 'Update Vault' : 'Add Vault',
      {
        closeOnClickOutside: true,
        onClose: closeModal,
        width: 800,
      }
    );
  };

  //   const onUpdateCdmDataSource = row => navigate(row.original.id);

  useEffect(() => {
    root &&
      dispatch(
        setBreadcrumbs([
          {
            name: 'Settings',
            path: `${root.rootPath}`,
          },
          {
            name: 'Vaults',
            path: `${root.rootPath}/vaults`,
          },
        ])
      );
  }, [root]);

  return (
    <PageList<any, any, IndexComponentConfigInterface>
      reloadId={idReload}
      isImport={false}
      isCreate={true}
      onCreate={onCreateVault}
      moduleConfig={
        {
          rootSettings: {
            rootPath: '/admin',
            rootTitle: '',
          },
        } as any
      }
      listConfig={{
        ...vaultListConfig,
      }}
      onRowClick={row => onCreateVault(null, row.original)}
      variant="secondary"
      allowDelete={true}
    />
  );
};
